// Real auth is the httpOnly cookie. localStorage.id is only a UI/session signal
// set on login and cleared on logout (JS cannot read httpOnly cookies).
export function isLoggedIn() {
  return localStorage.getItem("id") != null;
}

// Kept so existing imports of getAuthToken keep compiling during the migration.
// Returns the session id when logged in, otherwise null (truthy/falsy same as before).
export function getAuthToken() {
  return isLoggedIn() ? localStorage.getItem("id") : null;
}
